export default __webpack_public_path__ + "static/media/transposicao.79fa5603.png";